import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../store'

export type CountryFilterState = {
  selectedCountryId?: string
}

const initialState: CountryFilterState = {}

export const countryFilterSlice = createSlice({
  name: 'countryFilter',
  initialState,
  reducers: {
    setSelectedCountryId: (state, action: PayloadAction<string>) => {
      state.selectedCountryId = action.payload
    },
  },
})

export const { setSelectedCountryId } = countryFilterSlice.actions

export const selectSelectedCountryId = (state: RootState) =>
  state.countryFilter.selectedCountryId
